import { render, staticRenderFns } from "./CostRegIdxComboBox.vue?vue&type=template&id=4c5d3122&scoped=true"
import script from "./CostRegIdxComboBox.vue?vue&type=script&lang=js"
export * from "./CostRegIdxComboBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5d3122",
  null
  
)

export default component.exports